import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";

@Injectable({ providedIn: 'root' })
export class SeasonGuard implements CanActivate {

    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const season = route.paramMap.get('season');

        // Valid? 4-digit number?
        if (/^\d{4}$/.test(season ?? '')) {
            return true;
        }

        // Invalid -> return to home page
        this.router.navigateByUrl('/', { replaceUrl: true });
        return false;
    }
}
